module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-23.d40c137e.png";